/** The register a shop addresses its customers in. Integer on the wire, like `ShopType`. */
export enum ShopTone {
  Formal = 0,
  Informal = 1,
}

/** Non-nullable on the backend, so anything outside the enum reads as formal rather than blanking the select. */
export const toShopTone = (tone: ShopTone): ShopTone =>
  tone === ShopTone.Informal ? ShopTone.Informal : ShopTone.Formal;
